const StudentDetails = () => {
    return (
        <div id="student" className="vision-card">
                <h3>STUDENT DETAILS</h3>

                <div className="table-section-wrap">
                    <table className="table-section">
                        <thead>
                            <tr>
                                <th>CLASS</th>
                                <th>TOTAL NUMBER OF SECTIONS</th>
                                <th>TOTAL NUMBER OF INTAKE</th>
                                <th>TOTAL NUMBER OF STUDENTS</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr><td>1</td><td>1</td><td></td><td>39</td></tr>
                            <tr><td>2</td><td>1</td><td></td><td>42</td></tr>
                            <tr><td>3</td><td>1</td><td></td><td>41</td></tr>
                            <tr><td>4</td><td>1</td><td></td><td>40</td></tr>
                            <tr><td>5</td><td>1</td><td></td><td>43</td></tr>
                            <tr><td>6</td><td>2</td><td></td><td>81</td></tr>
                            <tr><td>7</td><td>2</td><td></td><td>84</td></tr>
                            <tr><td>8</td><td>2</td><td></td><td>84</td></tr>
                            <tr><td>9</td><td>13</td><td></td><td>542</td></tr>
                            <tr><td>10</td><td>11</td><td></td><td>458</td></tr>
                            <tr><td>11</td><td>8</td><td></td><td>311</td></tr>
                            <tr><td>12</td><td>10</td><td></td><td>384</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
    );
};

export default StudentDetails;